/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChangePasswordRequest } from '../models/ChangePasswordRequest';
import type { PasswordResponse } from '../models/PasswordResponse';
import type { SetPasswordRequest } from '../models/SetPasswordRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PasswordService {
    /**
     * Set password for current user
     * Set a password for the current user (only works if user doesn't have a password, requires escalation)
     * @param requestBody
     * @param userSession
     * @returns PasswordResponse Successful Response
     * @throws ApiError
     */
    public static setPassword(
        requestBody: SetPasswordRequest,
        userSession?: (string | null),
    ): CancelablePromise<PasswordResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/password/set',
            cookies: {
                'user_session': userSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Change password for current user
     * Change the password for the current user (requires escalation)
     * @param requestBody
     * @param userSession
     * @returns PasswordResponse Successful Response
     * @throws ApiError
     */
    public static changePassword(
        requestBody: ChangePasswordRequest,
        userSession?: (string | null),
    ): CancelablePromise<PasswordResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/password/change',
            cookies: {
                'user_session': userSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
